module.exports = __webpack_public_path__ + "img/pix-light.bbd52f83.svg";